export default __webpack_public_path__ + "images/assets/6601d9f243b8308d6d21256027b3816d.svg";